import DatePicker, { registerLocale } from 'react-datepicker';
import { bs } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './DateTimePickerForm.css';
import ReportIssueError from '../../../../reportissue/components/ReportIssueError';
import { ErrorMessage } from 'formik';
import '../workorder/WorkOrderForm.css';

function DateTimePickerForm({
  dateTimePickerName,
  dateTimePickerLabel,
  dateValue,
  setFormDate,
  validateDate,
}) {
  registerLocale('bs', bs);

  const onDatepickerRef = (el) => {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  };

  return (
    <div className="wo-form-field-container">
      <label htmlFor={dateTimePickerName} className="wo-form-label">
        {dateTimePickerLabel}
      </label>
      <DatePicker
        selected={dateValue}
        onChange={(date) => {
          setFormDate(dateTimePickerName, date);
          validateDate();
        }}
        ref={(el) => onDatepickerRef(el)}
        showTimeSelect
        timeFormat="HH:mm"
        dateFormat="dd.MM.yyyy. 'u' HH:mm 'sati'"
        placeholderText="Odaberite datum i vrijeme"
        timeIntervals={15}
        className="work-order-form-field"
        onKeyDown={(e) => e.preventDefault()}
        timeCaption="vrijeme"
        locale="bs"
        id={dateTimePickerName}
        name={dateTimePickerName}
        autoComplete="off"
      />
      <ErrorMessage name={dateTimePickerName} component={ReportIssueError} />
    </div>
  );
}

export default DateTimePickerForm;
